import { typography } from '@joor/design-system'
import styled from 'styled-components'

export const StyledHeader = styled.div`
  width: 100%;
  font-family: var(--font-family-alpha);
  font-weight: var(--font-weight-regular);
  font-size: 26px;
  line-height: 32px;
  letter-spacing: 1.2px;
  color: var(--color-primary-700);
  border-bottom: 1px solid var(--color-primary-300);
  padding: 0 0 8px 0;
`
export const StyledContent = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: row;

  > div {
    flex: 1 1 25%;
    min-width: 0;
  }
  > div:not(:last-child) {
    border-right: 1px solid var(--color-primary-200);
  }
  @media only screen and (max-width: 1600px) {
    flex-direction: column;
    > div {
      flex: 1 1 auto;
      border-right: none !important;
    }
  }
  @media only screen and (max-width: 767px) {
    flex-wrap: wrap;
  }
  @media only screen and (max-width: 576px) {
    flex-direction: column;
    > div {
      flex: 1 1 auto;
      border-right: none !important;
    }
  }
`
export const StyledTitle = styled.div`
  ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-500);
  line-height: var(--line-height-16);
  letter-spacing: var(--letter-spacing-tighter);
  margin-bottom: 8px;
`
export const StyledText = styled.div`
  font-family: var(--font-family-alpha);
  font-weight: var(--font-weight-medium);
  font-size: var(--size-font-base);
  color: var(--color-primary-800);
  line-height: var(--line-height-10);
  letter-spacing: var(--letter-spacing-tight);
  word-break: break-word;
  text-wrap: balance;
  min-width: 0;
  overflow: hidden;
`
export const StyledAddress = styled.div`
  font-family: var(--font-family-alpha);
  font-weight: var(--font-weight-medium);
  font-size: var(--size-font-base);
  color: var(--color-primary-800);
  line-height: var(--line-height-10);
  letter-spacing: var(--letter-spacing-tight);
  margin-top: 8px;
  margin-right: 4px;
  word-break: break-word;
  text-wrap: balance;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
export const StyledSection = styled.div`
  margin: 8px 0 32px;
  min-width: 0;
`
export const StyledSectionWithFlex = styled.div`
  margin: 8px 0 16px;
  @media only screen and (min-width: 768px) {
    max-height: 440px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  @media only screen and (min-width: 1600px) {
    max-height: 360px;
  }
`
export const StyledSubSection = styled.div`
  margin: 8px 10px 8px 0;
`
export const StyledPill = styled.span`
  display: inline-block;
  background-color: var(--color-primary-100);
  border-radius: 20px;
  padding: 4px 12px;
  font-family: var(--font-family-alpha);
  font-weight: var(--font-weight-medium);
  font-size: var(--size-font-base);
  color: var(--color-primary-800);
  line-height: var(--line-height-10);
  letter-spacing: var(--letter-spacing-tight);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`
export const StyledPillContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
`
